module.exports = __webpack_public_path__ + "static/media/apas.6b432a80.jpg";